SlideView  = require("views/slide")
{ DraggyView } = require("views/components/draggy")
Preload    = require("lib/preload")
Device     = require("lib/device")
fitText    = require("lib/fit-text")

class ImageGalleryView extends SlideView
  template: require("./template")

  currentIndex: 0

  events:
    "iostap .btn-done": "submit"
    "iostap .dot": "goToPage"

  serialize: ->
    data = super

    @options.data.images = data.images =
      (data.images or []).filter (m) ->
        m.image or m.caption.length > 0
    
    if @options.config().direction == "rtl" and !@options.data.isReversed
      data.images = data.images.reverse()
      @options.data.isReversed = true
    
    # Empty images array breaks the structure of ImageGallery template, hence initializing it
    if data.images.length == 0
      data.images.push({image: undefined, caption: ""})
    
    if data.images.length <= 1
      window.setTimeout (=> @setState "touched"), 0

    data.hasPrompt = true

    data

  beforeShow: ->
    lightboxColor =
      if @options.data.lightbox then  else "default"

    if @options.data.lightbox
      @trigger("ui", lightbox: @options.data.background or true)
    else
      @trigger("ui", lightbox: false)

  onRefresh: ->
    super
    @beforeShow()

  show: (index = 0) ->
    @draggy?.undelegateEvents()
    @draggy = null

    unless @draggy
      el = @findOne(".carousel")
      @setEl el.firstChild, "scroller"

      if @options.data.images.length > 1
        @setEl @findOne(".pagination"), "pagination"

        len = (@options.data.images.length - 1)
        min = -el.offsetWidth * len

        @draggy  = new DraggyView
          el: el
          minX: min
          maxX: 0
          lock: "y"

        @listenTo @draggy, "drag", @onDrag
        @listenTo @draggy, "drop", @onDrop

        if @options.config().direction is "rtl"
          x = -@draggy.el.offsetWidth * (len - Math.min(index, len))
        else
          x = -@draggy.el.offsetWidth * Math.min(index, len)

        @draggy.reset { x }

      else
        @getEl("scroller").firstChild.style.opacity = 1

      @listenTo this, "resize", @onResize
      @onResize()
      @limitImageSize()

  limitImageSize: ->
    images = _.chain(@options.data.images).pluck("image").compact().value()
    height = @getEl("scroller").offsetHeight

    Preload.load images, =>
      for child, i in @getEl("scroller").children
        child.style.fontSize = ""
        img = child.querySelector(".img")

        if img
          maxH = height
          if Device.breakpoint(["xs", "sm", "md"])
            text  = child.querySelector(".caption")
            maxH -= text?.offsetHeight or 0
          else
            shouldFitText = true

          img.style.maxHeight = "#{maxH}px"

        fitText(child) if shouldFitText

  onDrag: (draggy, isInitial) ->
    transition = if isInitial then "all 300ms" else "none"

    @transform @getEl("scroller"),
      x: @getScrollDist(draggy)
      transition: transition

    @updateChildren(draggy, transition)

  onDrop: (draggy, isReset) ->
    if isReset
      transition    = if @currentIndex? then "all 300ms" else ""
      @currentIndex = Math.floor(-draggy.x / draggy.offset.width)

      @transform @getEl("scroller"),
        x: @getScrollDist(draggy)
        transition: transition

      @updateChildren(draggy, transition)

    else
      x = draggy.velocity.x
      m = 0.9
      func =
        if x < -m then "ceil"
        else if x > m then "floor"
        else "round"

      step = Math[func](Math.min(draggy.x / draggy.offset.width, 1))

      draggy.reset x: step * draggy.offset.width

    for dot, i in @getEl("pagination").children
      dot.classList.toggle "active", i is @currentIndex

    if @options.config().direction is "rtl"
      if @currentIndex is 0
        @setState("touched")
    else
      if @currentIndex is @options.data.images.length - 1
        @setState("touched")

  goToPage: (e) ->
    index = e.currentTarget.dataset.page
    total = @options.data.images.length - 1
    @draggy.reset x: (index / total) * @draggy.options.minX

  updateChildren: (draggy, transition) ->
    { width } = draggy.offset

    for child, i in @getEl("scroller").children
      if transition
        child.classList.toggle("active", i is @currentIndex)
        @transition(child, transition, true)

      @transform child,
        scale:   1 - Math.abs(draggy.x + (i * width)) / width / 5
        opacity: 1 - Math.abs(draggy.x + (i * width)) / width

  getScrollDist: (draggy) ->
    "#{
      draggy.x / draggy.offset.width / @options.data.images.length * 100
    }%"

  onResize: ->
    @limitImageSize()

    if scroller = @getEl("scroller") and @draggy
      @draggy.options.minX =
        -@draggy.el.offsetWidth * (@options.data.images.length - 1)
      @draggy.getOffset()

  refresh: (params) ->
    images = params.data.images

    # Handle pagination when empty sections are added, clearing empty sections from array
    if params.data.images.length != @options.data.images.length
      images = (params.data.images or []).filter (m) -> m.image or m.caption.length > 0
      changed = @currentIndex

    for image, i in images
      # Filter section which was changed
      if not _.isEqual(image, @options.data.images[i])
        changed = i
        break

    super

    if @draggy
      @draggy.undelegateEvents()
      @draggy = @currentIndex = null

    @show(changed)

  screenshot: ->
    total = @options.data.images.length - 1

    new Promise (resolve, reject) =>
      getPages = (images = []) =>
        if images.length <= total
          index = images.length

          @draggy?.reset x: (index / total) * @draggy.options.minX
          @collateScreenshots(images)
            .then(getPages)
            .catch(reject)
        else
          resolve(images)

      getPages()

module.exports = ImageGalleryView
